import React from 'react';
import { IconProps } from '../Icon.types';

const ServiceIcon: React.FunctionComponent<IconProps> = ({ colourFill }) => {
  return (
    <svg width="76" height="76" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 76 76">
      <path
        d="m18.79,29.54c3.12-.02,6.18.76,9.21,2.37v25.82c-2.86-1.94-5.54-2.94-8.32-2.91-2.82.03-5.68,1.11-8.86,3.17l-1.55-26.07c3.24-1.55,6.4-2.36,9.51-2.38h0Z"
        fill={colourFill}
        fillRule="evenodd"
      />
      <path
        d="m38.21,29.54c3.11.02,6.27.82,9.52,2.38l-1.55,26.07c-3.18-2.06-6.04-3.14-8.86-3.17-2.77-.02-5.46.97-8.31,2.91v-25.82c3.03-1.61,6.09-2.39,9.21-2.37h0Z"
        fill={colourFill}
        fillRule="evenodd"
      />
      <path
        d="m48.69,35.73l2.41.68-1.18,25.6h-20.91v-2.73c2.92-2.19,5.55-3.22,8.23-3.2,2.75.02,5.63,1.18,9.07,3.93h0c.19-.24.43-.22.64-.32.2-.1.34-.3.35-.53l1.39-23.43Z"
        fill={colourFill}
        fillRule="evenodd"
      />
      <path
        d="m7.55,34.85l1.43,24.15h0c.02.23.15.44.37.55.21.1.46.08.65-.05,3.57-2.47,6.55-3.66,9.4-3.69,2.77-.02,5.49,1.04,8.6,3.31v2.88H6.35l-1.3-26.53,2.5-.62h0Z"
        fill={colourFill}
        fillRule="evenodd"
      />
      <path
        d="m27.97,10.44c-.09,0-.17.02-.24.06L1.44,23.25c-.14.04-.25.12-.33.24,0,.01-.02.02-.03.04-.08.13-.11.28-.09.43v4.28c-.04.24.07.49.27.62.01,0,.02.02.03.02,0,0,0,0,.01,0,.21.12.47.11.67-.03l26.01-12.62,26.01,12.62c.2.14.47.15.68.02,0,0,.02-.01.03-.02,0,0,.01,0,.02-.01.2-.14.3-.37.26-.62v-4.28h0c.02-.14,0-.28-.07-.4,0-.02-.02-.03-.02-.04-.08-.13-.21-.22-.35-.26l-26.28-12.75c-.09-.05-.2-.07-.3-.06h0Z"
        fill={colourFill}
        fillRule="evenodd"
      />
      <path
        d="m28,11.7l26,12.61v3.15l-26-12.61v.14c-.17-.09-.37-.09-.54,0L2,27.33v-3.02l26-12.61h0Z"
        fill={colourFill}
        fillRule="evenodd"
      />
    </svg>
  );
};

export default ServiceIcon;
